import { NotifyHelper } from "../../../helpers/toast";
import { eXepTKBActionsObj } from "../../action-types/tkb/IXepTKBActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const xepTKBActions = {
  ...generateActions(eXepTKBActionsObj, "XEP_TKB"),
  ...generateActionForKey(eXepTKBActionsObj, "XEP_TKB", "UPDATE_SUKIEN_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eXepTKBActionsObj, "XEP_TKB", "UPDATE_SUKIEN_ERRR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(eXepTKBActionsObj, "XEP_TKB", "UPDATE_GV_PH_SUKIEN_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eXepTKBActionsObj, "XEP_TKB", "UPDATE_GV_PH_SUKIEN_ERRR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(eXepTKBActionsObj, "XEP_TKB", "UPDATE_NHOMLOP_SUKIEN_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eXepTKBActionsObj, "XEP_TKB", "UPDATE_NHOMLOP_SUKIEN_ERROR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(eXepTKBActionsObj, "XEP_TKB", "UPDATE_PHONG_HOC_SUKIEN_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eXepTKBActionsObj, "XEP_TKB", "UPDATE_PHONG_HOC_SUKIEN_ERRR", (m) => { NotifyHelper.Error(m) }),

};
